import "./LegalNotice.module.css";
import Header from "@/reusable_sections/Header";
import LegalTerms from "./sections/LegalTerms";
import Footer from "@/reusable_sections/Footer";
export default function LegalNoticePage() {
  return <div>
      <Header />
      <LegalTerms />
      <Footer />
    </div>;
}